export default __webpack_public_path__ + "static/media/bg-header.1836f1c8.png";